import { render } from "./SectionNavigation.vue?vue&type=template&id=bc0e1248"
import script from "./SectionNavigation.vue?vue&type=script&lang=js"
export * from "./SectionNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__